import { PaginatorResponse } from "src/app/modules/utils/model/pages-and-components.config"; 
import { TemplateConfiguration, WhatsappButton } from "./templateConfiguration.model";
import { Attachment } from "../../accounts-receivable/model/paymentOrder.model";
import { TranslateService } from "@ngx-translate/core";

export class Template {
  id: string;
  activeVersionNumber: string;
  registerDate: string;
  registrationBoUserId: string;
  projectId: string;
  active: boolean;
  status: string;
  name: string;
  channelType: string;
  parentTemplateId: string;
  configuration: TemplateConfiguration = new TemplateConfiguration();
  hasFooter: boolean | null;
  hasHeader: boolean | null;
  onlyForGeneralConfiguration : boolean | null;
  onlyForCampaign : boolean | null;
  onlyForCommunicationFlow : boolean | null;
  assigned : boolean;
  recipientType: string;
  templateAttachmentIds : string[];
  sendFormButton: boolean;
  externalProviderId : string;
  externalProviderStatus : string;
  staticAttachmentsUrl : Attachment[];
  clientAttachmentConfiguration : ClientAttachmentConfiguration;
  additional_data : AdditionalData;
  clientId: string | null;
  type : string | null;
  externalProviderCategory: string | null;
  whatsappCallToActions : WhatsappButton[] | null
}
export class TemplateStatisticsData{
  sentEventTotalCount:number;
  deliveredEventTotalCount:number;
  sentEventDestinationCount:number;
  deliveredDestinationEventCount:number;
  openEventDestinationCount:number;
  clickEventDestinationCount:number;
  failedEventDestinationCount:number;
}

export class AdditionalData{
  vozyAgentCode:string;
  provider:string;
  exampleLink:string;
}

export class TemplateFormStep {
  id: number;
  title: string;
  description: string;
  panelTitle: string;
  panelDescription?: string;
}

export enum VozyAgentCode {
  COBRANZA_PAGO_VENCIDO = 'COBRANZA_PAGO_VENCIDO',
  COBRANZA_PAGO_HOY = 'COBRANZA_PAGO_HOY',
  COBRANZA_PARCIAL = 'COBRANZA_PARCIAL',
  COBRANZA_MORA = 'COBRANZA_MORA',
  MOONFLOW_BIENVENIDA = 'MOONFLOW_BIENVENIDA',
}

export class TemplateWithStatisticsPageable{
  content : TemplateWithStatistics[];
}

export class TemplateWithStatistics extends Template{
  data : TemplateStatisticsData;
  events: AssignmentDetail[];
  communicationFlows: AssignmentDetail[];
  campaigns: AssignmentDetail[];
}

export class AssignmentDetail{
  id:string;
  name:string;
}

export class ClientAttachmentConfiguration{
  clientAttachment1:boolean;
  clientAttachment2:boolean;
  purchaseOrderAttachment1:boolean;
  purchaseOrderAttachment2:boolean;
}

export class TemplatePaginationResponse extends PaginatorResponse{
  content: Template[];
}

export class TemplateTest extends Template {
  templateId?: string | null;
  destination?: string | null;
  templateGeneralConfigurationLogId? : string | null;
}

export enum ChannelType {
  EMAIL_CHANNEL_TYPE = 'E',
  SMS_CHANNEL_TYPE = 'S',
  WHATSAPP_CHANNEL_TYPE = 'W',
  WHATSAPP_CLOUD_API_CHANNEL_TYPE = 'A',
  PHONE_CALL = 'C',
  CHANNEL_TYPE_TRUNK_CALL = "P",
  FIELD_MANAGEMENT = 'F',
  VOICE_ASSISTANT = 'I',
  EXTERNAL_CHANNEL_TYPE = 'X',
  NOTE = 'N',
  ALTERNATIVE = 'L',
  VOICE_NOTE_CHANNEL_TYPE = 'V',
  PHYSICAL_LETTER_CHANNEL_TYPE = 'M',
  PHONE = 'P',
}

export enum TemplateExternalProviderStatus{
  REVIEW_EXTERNAL_PROVIDER_STATUS = 'R',
  APPROVED_EXTERNAL_PROVIDER_STATUS = 'A',
  FAILED_EXTERNAL_PROVIDER_STATUS = 'F',
  DELETED_EXTERNAL_PROVIDER_STATUS = 'D',
  DISABLED_EXTERNAL_PROVIDER_STATUS = 'I',
}

export enum RecipientType {
  CLIENT_RECIPIENT_TYPE = 'C',
  REFERENTS_RECIPIENT_TYPE = 'R',
  GUARANTORS_RECIPIENT_TYPE = 'G',
  BUSINESS_CONTACT_RECIPIENT_TYPE = 'B',
  PARENT_RECIPIENT_TYPE = 'P',
}

export enum TagShowComponentEnum{
  TEMPLATE_SUBJECT = 'TS',
  TEMPLATE_BODY = 'TB',

  TEMPLATE_EMAIL_CHANNEL_TYPE = 'E',
  TEMPLATE_SMS_CHANNEL_TYPE = 'S',
  TEMPLATE_WHATSAPP_CHANNEL_TYPE = 'W',
  TEMPLATE_WHATSAPP_CLOUD_API_CHANNEL_TYPE = 'A',
  TEMPLATE_PHONE_CALL = 'CL',
  TEMPLATE_FIELD_MANAGEMENT = 'F',

  ATTACHMENT_SUBJECT = 'AS',
  ATTACHMENT_BODY = 'AB',
  CONVERSATION_REPONSE = 'CR',
  CONVERSATION_SUBJECT_REPONSE = 'CS',

  FOR_ACCOUNT_STATUS='FAS',

  FOR_PAYMENT_METHOD='FPM'
}

export enum TemplateType {
  PROJECT_TYPE = "P",
  CREDIT_SCHEDULE_TYPE = "CS",
}

export enum TemplateStatus {
  CREATED_STATUS = "C",
  DELETED_STATUS = "D",
}

export enum AttachmentValues{
  ClientAttachment1 = 1,
  ClientAttachment2 = 2,
  PurcharseOrderAttachment1 = 3,
  PurcharseOrderAttachment2 = 4,
}

export enum ExternalProviderCategory {
  UTILITY_CATEGORY = "WU",
  MARKETING_CATEGORY = "WM",
}


// Class and Enum create only for Generate Template with IA

export class GenerateTemplateIaRequest{
  channel : string;
  destination : string;
  type : string;
  detail : string;
  userPrompt : string;
  portfolioType : string;
  labels : TagsLabels[];
}

export class TagsLabels{
  code : string;
  reference : string;
}

export class GenerateTemplateIaPublicResponse{
  statusCode : number;
  body : string;
  subject : string;
  approved : boolean;
}

export class ContextInformationPrompt{
  value : string;
  svg : string;
  text : string;
}

// USE ONLY ONE FRONT
export class DtoContextInformationTemplateWithIa{
  channel: string;
  type: string;
  selectedDetailPromptAI: string;
  extraInstructions: string;
  generatedBody: string;
  generateSubject : string;
  selectRecipientType : string;
}
 
export enum SituationFlowPromptAI{
  CLI_STATUS_PREV = "prev", // Para cobranza preventiva o sea, antes del vencimiento
  CLI_STATUS_DIA_D = "diaD", // La fecha de vencimiento es hoy
  CLI_STATUS_M_TEMP = "tem", // El cliente está en mora temprana (<= 45 días)
  CLI_STATUS_M_TARD  = "tar", // El cliente está en mora tardía (> 45 días)
}

export enum TypeNotificationGeneralFLow{
  COMMITMENT_THREE_DAYS_BEFORE_PAYMENT ='COMMITMENT_THREE_DAYS_BEFORE_PAYMENT',
  COMMITMENT_ONE_DAY_BEFORE_PAYMENT ='COMMITMENT_ONE_DAY_BEFORE_PAYMENT',
  PAYMENT_COMMITMENT_DAY ='PAYMENT_COMMITMENT_DAY',
  VERIFY_PAYMENT_NOTIFICATION ='VERIFY_PAYMENT_NOTIFICATION',
  TOTAL_PAYMENT_NOTIFICATION ='TOTAL_PAYMENT_NOTIFICATION',
  PARTIAL_PAYMENT_NOTIFICATION ='PARTIAL_PAYMENT_NOTIFICATION',
  NEW_PAYMENT_ORDER ='NEW_PAYMENT_ORDER',
  PAYMENT_NOT_CONFIRMED ='PAYMENT_NOT_CONFIRMED',
  PAYMENT_CREDITED ='PAYMENT_CREDITED',
  NOTIFICATION_DATE_EXPIRY_COMMITMENT = 'NOTIFICATION_DATE_EXPIRY_COMMITMENT',
  NEW_PAYMENT_COMMITMENT = 'NEW_PAYMENT_COMMITMENT', 

  COMMITMENT_THREE_DAYS_BEFORE_RECOVERY ='COMMITMENT_THREE_DAYS_BEFORE_RECOVERY',
  COMMITMENT_ONE_DAY_BEFORE_RECOVERY ='COMMITMENT_ONE_DAY_BEFORE_RECOVERY',
  PAYMENT_COMMITMENT_DAY_RECOVERY ='PAYMENT_COMMITMENT_DAY_RECOVERY',
  VERIFY_PAYMENT_NOTIFICATION_RECOVERY ='VERIFY_PAYMENT_NOTIFICATION_RECOVERY',
  TOTAL_PAYMENT_RECOVERY_NOTIFICATION ='TOTAL_PAYMENT_RECOVERY_NOTIFICATION',
  PARTIAL_PAYMENT_RECOVERY_NOTIFICATION ='PARTIAL_PAYMENT_RECOVERY_NOTIFICATION',
  NEW_RECOVERY_CAMPAIGN ='NEW_RECOVERY_CAMPAIGN',
  PAYMENT_NOT_CONFIRMED_RECOVERY ='PAYMENT_NOT_CONFIRMED_RECOVERY',
  PAYMENT_COMMITMENT_ONE_DAY_AFTER = 'PAYMENT_COMMITMENT_ONE_DAY_AFTER',
  PAYMENT_COMMITMENT_ONE_AFTER_DAY_RECOVERY = 'PAYMENT_COMMITMENT_ONE_DAY_AFTER_RECOVERY',
  PAYMENT_CREDITED_RECOVERY ='PAYMENT_CREDITED_RECOVERY',
  NEW_PAYMENT_COMMITMENT_RECOVER = 'NEW_PAYMENT_COMMITMENT_RECOVERY'
}

export enum CommunicationStrategy{
  FLOW = 'S',
  EVENT = 'E',
  CAMPAIGN = 'C'
}